import { render } from "./CodexView.vue?vue&type=template&id=49abba3e&scoped=true"
import script from "./CodexView.vue?vue&type=script&lang=js"
export * from "./CodexView.vue?vue&type=script&lang=js"

import "./CodexView.vue?vue&type=style&index=0&id=49abba3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49abba3e"]])

export default __exports__